/* global module, require */
const THREE = require('three'),
	steel = require('../mat/steel');

module.exports = function makeTopRail({ start, between, radius, height }) {
	const bar = new THREE.CylinderBufferGeometry(
		radius,
		radius,
		between.length()
	);
	const mesh = new THREE.Mesh(bar, steel);

	mesh.rotation.y = Math.PI / 2 + Math.atan2(between.x, between.z);
	mesh.rotation.z = Math.PI / 2;

	const dir = new THREE.Vector3()
		.copy(between)
		.divideScalar(2)
		.add(start);
	mesh.position.x = dir.x;
	mesh.position.y = height + radius;
	mesh.position.z = dir.z;

	return mesh;
};
